import React, { useState, useEffect } from "react";
import {
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  SelectChangeEvent,
  Checkbox,
  ListItemText,
} from "@mui/material";

interface SelectDropdownProps {
  label: string;
  value: string[]; // multiple selection
  filterKey: string;
  options: { key: number | string; value: string }[];
  onChange: (selected: string[]) => void;
  isError?: boolean;
  isDisabled?: boolean;
}

const MultiSelectDropdown: React.FC<SelectDropdownProps> = ({
  label,
  filterKey,
  options,
  onChange,
  isError = false,
  value,
  isDisabled = false,
}) => {
  const [selectedValues, setSelectedValues] = useState<string[]>(value || []);

  // Reset invalid values if options change
  useEffect(() => {
    console.log("!!!", selectedValues, value);
    if (!options) return;
    const validSelected = selectedValues.filter((sel) =>
      options.some((option) => option?.key?.toString() === sel)
    );
    if (validSelected.length !== selectedValues.length) {
      setSelectedValues(validSelected);
    }
  }, [options]);

  // Update selectedValues when parent value changes
  useEffect(() => {
    setSelectedValues(value || []);
  }, [value]);

  useEffect(() => {
    console.log("selectedValues", selectedValues);
  }, [selectedValues]);

  const handleChange = (event: SelectChangeEvent<string[]>) => {
    const newValue = event.target.value as string[];
    setSelectedValues(newValue);
    onChange(newValue);
  };

  return (
    <FormControl sx={{ minWidth: 200 }}>
      <InputLabel shrink>{label}</InputLabel>
      <Select
        multiple
        disabled={isDisabled}
        value={selectedValues}
        onChange={handleChange}
        renderValue={(selected) => {
          if (!selected.length) return <span>&nbsp;</span>;
          const selectedOptions = options.filter((option) =>
            selected.includes(option.key.toString())
          );
          return selectedOptions.map((opt) => opt.value).join(", ");
        }}
        sx={{
          borderRadius: "8px",
          fontSize: "14px",
          background: "white",
          color: isError ? "red" : "rgb(196 196 196)",
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: isError ? "red" : "rgb(196 196 196)",
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: isError ? "red" : "black",
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: isError ? "red" : "blue",
          },
        }}
      >
        {options && options.length > 0 ? (
          options.map((option) => (
            <MenuItem key={option.key} value={option.key.toString()}>
              <Checkbox
                checked={selectedValues.includes(option.key.toString())}
              />
              <ListItemText primary={option.value} />
            </MenuItem>
          ))
        ) : (
          <MenuItem disabled>No options available</MenuItem>
        )}
      </Select>
    </FormControl>
  );
};

export default MultiSelectDropdown;
